import React from 'react';
import { Switch, Route } from 'react-router-dom';
import OracleCourses from './OracleCourses';
import OracleLearningPath from './pages/OracleLearningPath';
import OracleLkmExperts from './OracleLkmExperts';
import OracleNavBar from './OracleNavBar';
import OracleTestimonial from './OracleTestimonial'
import Calendar from './pages/Calendar'
import Feedback from './pages/Feedback'
import FeedbackData from './pages/FeedbacksData';
import OracleLkmAwards from './OracleLkmAwards';

const OracleRouting = () => {
  return (
      <Switch>     
          <Route exact path="/Oracle/Courses" component={OracleCourses}/>  
          <Route exact path="/Oracle/Course/:code" component={OracleCourses}/>        
          <Route exact path="/Oracle/LearningPaths">
                <OracleNavBar />
              <OracleLearningPath />
          </Route>   
          <Route exact path="/Oracle/Testimonials">
                <OracleNavBar />
              <OracleTestimonial />
          </Route> 
          <Route exact path="/Oracle/LkmExperts">
                <OracleNavBar />
             <OracleLkmExperts />
          </Route>
          {/* <Route exact path="/Oracle/calendar">
                <OracleNavBar />
             <Calendar />
          </Route>   */}
          <Route exact path="/Oracle/Awards">
              <OracleNavBar />
              <OracleLkmAwards />
          </Route>
          <Route exact path="/Oracle/Feedback">
              <OracleNavBar />
              <Feedback />
          </Route>
          <Route exact path="/Oracle/Feedbacks">
              <OracleNavBar />
              <FeedbackData />
          </Route>
      </Switch>
  )
}

export default OracleRouting;